const mixin = {
  methods: {
    fixVinNumber (vinNumber) {
      return vinNumber?.toUpperCase().replace(/\s/g, '')
    }
  }
}


export default mixin
